// Add keyframes and animation classes
const fadeInAnimation = `
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-fade-in {
  animation: fadeIn 0.2s ease-out forwards;
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-slide-in-up {
  animation: slideInUp 0.4s ease-out forwards;
}

@keyframes celebrate {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}
.animate-celebrate {
  animation: celebrate 1s ease-in-out infinite;
}

@keyframes shine {
  0% { background-position: -100%; }
  100% { background-position: 200%; }
}
.animate-shine {
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 50%, rgba(255,255,255,0) 100%);
  background-size: 200% 100%;
  animation: shine 2s infinite;
}

@keyframes confetti-fall {
  0% { transform: translateY(-10px); opacity: 1; }
  100% { transform: translateY(40px); opacity: 0; }
}
.confetti {
  position: absolute;
  width: 8px;
  height: 8px;
  opacity: 0;
  animation: confetti-fall 1.5s ease-out forwards;
}

@keyframes pulse-record {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}
.animate-pulse-record {
  animation: pulse-record 1.5s ease-in-out infinite;
}

@keyframes equalizer-bar {
  0% { height: 3px; }
  50% { height: 10px; }
  100% { height: 3px; }
}
.equalizer-bar {
  display: inline-block;
  width: 3px;
  background-color: currentColor;
  margin: 0 1px;
  border-radius: 1px;
}
.equalizer-bar-1 { animation: equalizer-bar 0.9s ease-in-out infinite; }
.equalizer-bar-2 { animation: equalizer-bar 0.9s ease-in-out infinite 0.2s; }
.equalizer-bar-3 { animation: equalizer-bar 0.9s ease-in-out infinite 0.4s; }
.equalizer-bar-4 { animation: equalizer-bar 0.9s ease-in-out infinite 0.6s; }
`;

// Add animation styles to document
export const initializeStyles = () => {
  // Create style element for animations
  const styleEl = document.createElement("style");
  styleEl.innerHTML = fadeInAnimation;
  document.head.appendChild(styleEl);

  return () => {
    document.head.removeChild(styleEl);
  };
};

export default initializeStyles;
